import { render } from "./UserConfigPage.vue?vue&type=template&id=4421df34"
import script from "./UserConfigPage.vue?vue&type=script&lang=js"
export * from "./UserConfigPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__